module.exports = __webpack_public_path__ + "media/教室3.4da6fbe4.mp4";